var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "price-icon",
    transform: "translate(-1407 -2684)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4791",
    "data-name": "Rectangle 4791",
    width: 24,
    height: 24,
    transform: "translate(1407 2684)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons_Shopping_Tag_Line",
    "data-name": "icons/Shopping Tag/Line",
    transform: "translate(1407.908 2684.736)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M7.886,1.076A3.674,3.674,0,0,1,10.484,0h5.288a2.756,2.756,0,0,1,2.755,2.755V8.044a3.674,3.674,0,0,1-1.076,2.6L10.372,17.72a2.755,2.755,0,0,1-3.9,0L.807,12.052a2.755,2.755,0,0,1,0-3.9Zm2.6.761a1.837,1.837,0,0,0-1.3.538L2.106,9.454a.918.918,0,0,0,0,1.3l5.669,5.669a.919.919,0,0,0,1.3,0l7.079-7.079a1.837,1.837,0,0,0,.538-1.3V2.755a.918.918,0,0,0-.918-.918Z",
    transform: "translate(1.828 2)",
    fill: "#6b6b95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M0,1.3,1.3,0l9.565,9.565-1.3,1.3Z",
    transform: "translate(3.443 8.049)",
    fill: "#6b6b95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M2.755,3.674a.918.918,0,1,0-.918-.918A.919.919,0,0,0,2.755,3.674Zm0,1.837A2.755,2.755,0,1,0,0,2.755,2.755,2.755,0,0,0,2.755,5.511Z",
    transform: "translate(11.171 5.674)",
    fill: "#6b6b95"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceIcon);
export default __webpack_public_path__ + "static/media/price-icon.02897004e95aa0cda1f26c2a3729c93d.svg";
export { ForwardRef as ReactComponent };